import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VaporDatePicker } from "../../../vapor";

/**
 * Fields for asset assignment and revocation in drawer footer
 * This is an array components
 * @returns
 */
const AssignmentAndRevocationDrawerFields = ({ editable, setEditable, setModifiedFields, modifiedFields, setDisableSaveButton, setIsFringeBenefitVisible }) => {
  const activationDate = editable?.activationDate;
  const [state, setState] = useState(editable.reducedDeductibilityGoods || [{
    "mixedUse": "NO",
    "assignmentDate": moment(activationDate),
    "revocationDate": null
  }]);
  /**
     * Add a new row to the component in a specific position
     * @param {} index where add the new row
     */
  const addRow = (index) => {
    let newState = [...state];
    newState.splice(
      index + 1, 0, {
        "mixedUse": "NO",
        "assignmentDate": null,
        "revocationDate": null
      }
    );
    setState(newState);
  };

  /**
     * Remove one of the rows of the component
     * @param {*} index of the row to remove
     */
  const removeRow = (index) => {
    let newState = [...state];
    newState.splice(index, 1);
    setState(newState);
    patchData(newState);
  };

  /**
     * Autosave the data in the component anytime the user change something in the select
     * or remove the focus from the datepicker
     * @param {*} newState
     */
  const patchData = (newState = null) => {
    const sendState = newState ? newState : state;
    let checkValidData = true;
    sendState.forEach((element, index) => {
      if (!element.assignmentDate || (!element.revocationDate && index !== sendState.length - 1))
        checkValidData = false;
    });

    if (checkValidData) {
      let newModifiedFields = { ...modifiedFields };
      newModifiedFields["reducedDeductibilityGoods"] = sendState;
      newModifiedFields["autosaveEnabled"] = true;
      let newEditableFields = { ...editable };
      newEditableFields["reducedDeductibilityGoods"] = sendState;
      setModifiedFields(newModifiedFields);
      setEditable(newEditableFields);
      setDisableSaveButton(false);      
    } else {      
      setDisableSaveButton(true);
    }
  };

  /**
     * Render dinamically the component depending on the number of rows
     * @returns
     */
  const renderContent = () => {
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
    let objects = [];
    for (let i = 0; i < state.length; i++) {
      const mixedUseId = "mixedUse";
      const assignmentDateId = "assignmentDate";
      const revocationDateId = "revocationDate";
      const mixedUseValid = ["EMPLOYEE", "ADMINISTRATOR"].includes(state[i][mixedUseId]);

      objects.push(<div className="pre-cog-assets-drawer-section" key={i}>
        <div style={{ width: "22%" }}>
          {<div className="precog-withholding-drawer-form—label-text"><FormattedMessage id={"preCog.assetsTab.drawer.mixedUseSelect"} /></div>}
          <Select
            className="pre-cog-assets-drawer-select"
            style={{ width: "100%" }}
            value={state[i][mixedUseId] || "No"}
            onChange={value => {
              let newState = [...state];
              newState[i][mixedUseId] = value;
              setState(newState);
              patchData(newState);
            }}
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            <Select.Option value="EMPLOYEE">Dipendente</Select.Option>
            <Select.Option value="ADMINISTRATOR">Amministratore</Select.Option>
            {i === state.length - 1 && <Select.Option value="No">No</Select.Option>}
          </Select>
        </div>

        {<div style={{ width: "23%" }} className={!mixedUseValid ? "precog-withholding-drawer-form-row-disabled" : ""}>
          <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center" }}>
            <FormattedMessage id={"preCog.assetsTab.drawer.assignmentDateToEmployee"} />
          </div>
          <VaporDatePicker
            getPopupContainer={(trigger) => trigger.parentNode}
            className={"precog-withholding-drawer-dateCustom" + (state[i][assignmentDateId] ? "" : " precog-withholding-drawer--error")}
            value={state[i][assignmentDateId] ? moment(state[i][assignmentDateId]) : undefined}
            onBlur={() => patchData()}
            onChange={e => {
              let newState = [...state];
              newState[i][assignmentDateId] = e;
              setState(newState);
              patchData(newState);
            }}
            format={dateFormatList}
            disabledDate={current => {
              let checkPrevius = false;
              if (i > 0 && state[i - 1][revocationDateId])
                checkPrevius = moment(state[i - 1][revocationDateId]).isAfter(current);
              return current && ((state[i][revocationDateId] && current > moment(state[i][revocationDateId])) || checkPrevius || moment(activationDate).isAfter(current));
            }}
            style={{ borderColor: "red" }}
            allowClear={false}
          />
        </div>}

        {<div style={{ width: "23%" }} className={!mixedUseValid ? "precog-withholding-drawer-form-row-disabled" : ""}>
          <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center" }}>
            <FormattedMessage id={"preCog.assetsTab.drawer.revocationDateToEmployee"} />
          </div>
          <VaporDatePicker
            format={dateFormatList}
            getPopupContainer={(trigger) => trigger.parentNode}
            className={"precog-withholding-drawer-dateCustom" + (state[i][revocationDateId] || i === state.length - 1 ? "" : " precog-withholding-drawer--error")}
            value={state[i][revocationDateId] ? moment(state[i][revocationDateId]) : undefined}
            onBlur={() => patchData()}
            onChange={e => {
              let newState = [...state];
              newState[i][revocationDateId] = e;
              setState(newState);
              patchData(newState);
            }}
            disabledDate={current => {
              let checkNext = false;
              if (i < state.length - 1 && state[i + 1][assignmentDateId])
                checkNext = moment(state[i + 1][assignmentDateId]).isBefore(current);
              return current && ((state[i][assignmentDateId] && current < moment(state[i][assignmentDateId])) || checkNext);
            }}
            allowClear={i === state.length - 1/* I can clear only the last revocation data */}
          />
        </div>}
        {<div className="precog-withholding-drawer-form—icons">
          <FontAwesomeIcon
            icon={["far", "trash-alt"]}
            className={"precog-withholding-drawer-form—icon" + (state.length <= 1 ? " precog-withholding-drawer-form—icon-disabled" : "")}
            style={{ color: "rgb(216, 40, 41)" }}
            onClick={() => {
              removeRow(i);
            }}
          />
          <FontAwesomeIcon
            icon={["fas", "plus-circle"]}
            className={"precog-withholding-drawer-form—icon" + (!state[i][assignmentDateId] || !state[i][revocationDateId] || i !== state.length - 1 ? " precog-withholding-drawer-form—icon-disabled" : "")}
            style={{ color: "rgb(0, 144, 209)" }}
            onClick={() => {
              addRow(i);
            }}
          />
        </div>}
      </div>);
    }
    return objects;
  };

  /**
   * When state change check if fringe benefit section is visible,
   * it is visible if we have at least 1 row with mixedUse=ADMINISTRATOR
   */
  useEffect(()=>{
    if (state.find(s => s.mixedUse === "ADMINISTRATOR"))
      setIsFringeBenefitVisible(true);
    else
      setIsFringeBenefitVisible(false);
  },[state]);

  /**
   * If activation date change and it is 
   */
  useEffect(()=>{
    if (moment(state[0].assignmentDate).isBefore(moment(activationDate))){
      const newState = [...state];
      newState[0].assignmentDate = activationDate;
      if (moment(newState[0].revocationDate).isBefore(newState[0].assignmentDate))
        newState[0].revocationDate = moment(newState[0].assignmentDate).add(1, "days");
      for (let i = 1; i<newState.length;i++){
        if (moment(newState[i].assignmentDate).isBefore(newState[i-1].revocationDate))
          newState[i].assignmentDate = moment(newState[i-1].revocationDate).add(1, "days");
        if (moment(newState[i].revocationDate).isBefore(newState[i].assignmentDate))
          newState[i].revocationDate = moment(newState[i].assignmentDate).add(1, "days");
      }
      setState(newState);
    }
  },[activationDate]);

  return (
    <React.Fragment>
      {renderContent()}
    </React.Fragment>

  );
};

export default AssignmentAndRevocationDrawerFields;
